import React, { useEffect, useState, useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import ModalContext from './ModalContext';
import ApiService from '../../services/ApiService';
import Form from '../form/Form';

// DBPPRD ||A:107296X*|2290|
const ModalPartPriceCheck = ({ lookupKey = null }) => {
  const [results, setResults] = useState('');
  const { close, setTitle } = useContext(ModalContext);
  const title = 'Part Price Check';

  const layout = [
    {
      name: 'partNumber',
      data: lookupKey,
      hidden: true,
    },
    {
      name: 'customerOrRepair',
      label: 'Lookup by Customer or Repair Order',
      data: '',
      required: true,
      options: [
        { label: 'Customer', value: 'C' },
        { label: 'Repair Order', value: 'R' },
      ],
    },
    {
      col: 6,
      name: 'customerId',
      label: 'Customer',
      validation: { page: 'AAR1', toolbar: ['customerHistory'] },
      required: true,
      dependencies: {
        and: [{ '==': ['customerOrRepair', 'C'] }],
        action: 'show',
      },
      hidden: true,
      events: {
        blur: {
          update: [
            {
              method: {
                name: 'customerlookup',
              },
            },
          ],
        },
      },
      data: '',
    },
    {
      type: 'section',
      label: 'Customer Information',
      fields: [
        {
          col: 6,
          name: 'customerName',
          label: 'Name',
          section: 'Customer Information',
          displayOnly: true,
          hidden: true,
          data: '',
          dependencies: {
            and: [{ '==': ['customerOrRepair', 'C'] }],
            action: 'show',
          },
        },
        {
          col: 6,
          name: 'customerCity',
          label: 'City',
          section: 'Customer Information',
          displayOnly: true,
          hidden: true,
          data: '',
          dependencies: {
            and: [{ '==': ['customerOrRepair', 'C'] }],
            action: 'show',
          },
        },
        {
          col: 6,
          name: 'customerAddress',
          label: 'Address',
          section: 'Customer Information',
          displayOnly: true,
          hidden: true,
          data: '',
          dependencies: {
            and: [{ '==': ['customerOrRepair', 'C'] }],
            action: 'show',
          },
        },
        {
          col: 6,
          name: 'customerState',
          label: 'State',
          section: 'Customer Information',
          displayOnly: true,
          hidden: true,
          data: '',
          dependencies: {
            and: [{ '==': ['customerOrRepair', 'C'] }],
            action: 'show',
          },
        },
        {
          col: 6,
          name: 'customerPhone',
          label: 'Phone',
          displayOnly: true,
          hidden: true,
          data: '',
          dependencies: {
            and: [{ '==': ['customerOrRepair', 'C'] }],
            action: 'show',
          },
        },
        {
          col: 6,
          name: 'customerZip',
          label: 'Zip',
          section: 'Customer Information',
          displayOnly: true,
          hidden: true,
          data: '',
          dependencies: {
            and: [{ '==': ['customerOrRepair', 'C'] }],
            action: 'show',
          },
        },
      ],
    },
    {
      label: 'Repair Order',
      name: 'repairId',
      data: '',
      required: true,
      validation: { page: 'SMM4' },
      dependencies: {
        and: [{ '==': ['customerOrRepair', 'R'] }],
        action: 'show',
      },
      hidden: true,
    },
    {
      label: 'Operation Number',
      name: 'operationId',
      data: '',
      required: true,
      dependencies: {
        and: [{ '==': ['customerOrRepair', 'R'] }],
        action: 'show',
      },
      hidden: true,
    },
    {
      label: 'Labor Type',
      name: 'laborType',
      data: '',
      require: true,
      options: [
        { label: 'Primary', value: 'P' },
        { label: 'Secondary', value: 'S' },
      ],
      dependencies: {
        and: [{ '==': ['customerOrRepair', 'R'] }],
        action: 'show',
      },
      hidden: true,
    },
  ];

  const reset = () => {
    setTitle(title);
    setResults('');
  };

  const submit = payload => {
    const partId = payload[0].data;

    const params = {};
    payload.forEach(param => {
      params[param.name] = param.data;
    });

    return ApiService.get(`part/${encodeURIComponent(partId)}/pricecheck`, { params });
  };

  const submitCallback = response => {
    setTitle(
      <div className="modal-icon-title">
        <div className="icon-wrapper">
          <i className="zmdi zmdi-arrow-left" onClick={reset} />
        </div>
        <div className="title-wrapper">Price Check Results</div>
      </div>
    );

    setResults(response.data.data);
  };

  useEffect(() => {
    reset();
  }, []);

  const entryClass = classNames({
    'entry-form': true,
    hidden: results,
    animated: true,
    fadeIn: !results,
  });

  const resultClass = classNames({
    'result-panel': true,
    hidden: !results,
    animatedFast: true,
    slideInRight: results,
  });

  return (
    <div>
      <div className={entryClass}>
        <Form
          layout={layout}
          submit={submit}
          submitCallback={submitCallback}
          onCancel={close}
          feedback="none"
          action="process"
          submitAll
          trackDirty={false}
        />
      </div>
      <div className={resultClass}>
        <pre>{results}</pre>
      </div>
    </div>
  );
};

ModalPartPriceCheck.propTypes = {
  // Passed in props
  lookupKey: PropTypes.string,
};

export default ModalPartPriceCheck;
